export default {
  rules: {
    required: '이 필드는 필수입니다',
    email: '유효한 이메일 주소를 입력하세요',
    url: '유효한 URL을 입력하세요',
    alpha: '문자만 허용됩니다',
    alphaNum: '문자와 숫자만 허용됩니다',
    numeric: '숫자만 허용됩니다',
    min: '{min} 이상이어야 합니다',
    max: '{max} 이하여야 합니다',
    minLength: '{min}자 이상이어야 합니다',
    maxLength: '{max}자 이하여야 합니다',
    between: '{min}에서 {max} 사이여야 합니다',
    confirmed: '입력이 일치하지 않습니다',
    date: '유효한 날짜를 입력하세요',
    dateFormat: '날짜는 {format} 형식이어야 합니다',
    dateAfter: '{date} 이후의 날짜여야 합니다',
    dateBefore: '{date} 이전의 날짜여야 합니다'
  },
  fields: {
    name: '이름',
    email: '이메일',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    message: '메시지',
    phone: '전화번호',
    subject: '제목',
    comments: '댓글',
    feedback: '피드백'
  }
}; 